import { render, staticRenderFns } from "./OnboardingScope.vue?vue&type=template&id=6d6fb0ee&"
import script from "./OnboardingScope.vue?vue&type=script&lang=js&"
export * from "./OnboardingScope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports